var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('loading-full'):_vm._e(),_c(_vm.layout,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }